import React, { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let scriptPromise = null;

function loadScript() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Failed to load Turnstile"));
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export default function Turnstile({ siteKey, onToken, onExpire, onError, theme = "dark", action }) {
  const ref = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!siteKey) return undefined;
    let mounted = true;

    loadScript()
      .then(() => {
        if (!mounted || !ref.current || !window.turnstile) return;
        widgetIdRef.current = window.turnstile.render(ref.current, {
          sitekey: siteKey,
          theme,
          action,
          callback: (token) => onToken && onToken(token),
          "expired-callback": () => onExpire && onExpire(),
          "error-callback": () => onError && onError(),
        });
      })
      .catch((e) => onError && onError(e));

    return () => {
      mounted = false;
      if (widgetIdRef.current && window.turnstile?.remove) {
        try { window.turnstile.remove(widgetIdRef.current); } catch (e) {}
        widgetIdRef.current = null;
      }
    };
  }, [siteKey, theme, action, onToken, onExpire, onError]);

  if (!siteKey) {
    return (
      <div className="error-msg">
        Turnstile site key missing. Set REACT_APP_TURNSTILE_SITE_KEY.
      </div>
    );
  }
  return <div ref={ref} />;
}
